export default __webpack_public_path__ + "static/media/complain.719f01ef.jpg";